import {
  loadColorCodes,
  loadDocuments,
  loadRelations,
  loadTasklist,
  loadTasks,
  loadUsers,
  loadVersions,
} from '@/Services/ProgrammationService'

type ServiceResponse = {
  data?: Record<string, any>
  error?: string
}

const readResponse = (response: ServiceResponse, key: string) => {
  if (response?.error || response?.data?.[key] === undefined) {
    throw new Error(response?.error || `Missing ${key} in programmation response`)
  }

  return response.data[key]
}

export const fetchProgrammationSnapshot = async (projectId: string) => {
  const [taskListResponse, tasksResponse, colorCodesResponse, usersResponse, documentsResponse] =
    await Promise.all([
      loadTasklist(projectId),
      loadTasks(projectId),
      loadColorCodes(projectId),
      loadUsers(projectId),
      loadDocuments(projectId),
    ])

  const taskList = readResponse(taskListResponse, 'taskList')
  const tasks = readResponse(tasksResponse, 'tasks')
  const colorCodes = readResponse(colorCodesResponse, 'colorCodes')
  const users = readResponse(usersResponse, 'users')
  const documents = readResponse(documentsResponse, 'documents')
  const taskIds = tasks.map((task: any) => task._id)

  const [relationsResponse, versionsResponse] = await Promise.all([
    loadRelations(projectId, taskIds),
    loadVersions(projectId, taskIds),
  ])

  return {
    list: taskList.list,
    tasks,
    users,
    colorCodes,
    relations: readResponse(relationsResponse, 'relations'),
    documents,
    versions: readResponse(versionsResponse, 'versions'),
  }
}
